import React, { Component } from "react";
import LayersWidget from "./LayersWidget";
import Constants from "../constants";
import ContourLayerWidget from "./ContourLayerWidget";

import "../App.css";
import tccLogo from "../img/tcc-logo.png";

class MainPage extends Component {
  render() {
    return (
      <div className="column border-blue first padding-column">
        <img src={tccLogo} alt="TCC" />
        <p className="left-column-para">{Constants.introductionText}</p>
        <div className="left-column-para-bottom">
          <hr />
          <p>
            <strong>Step 1:</strong> {Constants.step1Text}
          </p>
          <p>
            <strong>Step 2:</strong> {Constants.step2Text}
          </p>
          <p>
            <strong>Step 3:</strong> {Constants.step3Text}
          </p>
          <hr />
        </div>
        <ContourLayerWidget {...this.props} />
        <hr />
        <LayersWidget {...this.props} />
        <hr />
      </div>
    );
  }
}

export default MainPage;
